import { z } from "zod";
export const ReceiptStatusSchema = z.enum(["pending_review", "approved", "rejected"]);
export const ReceiptExtractionStatusSchema = z.enum([
    "pending",
    "processing",
    "complete",
    "failed",
]);
export const ReceiptSchema = z.object({
    id: z.string().uuid(),
    filename: z.string().min(1).max(500),
    blobKey: z.string().min(1),
    mimeType: z.string().max(100),
    sizeBytes: z.number().int().nonnegative(),
    supplierName: z.string().nullable(),
    receiptDate: z.string().date().nullable(),
    totalAmount: z.number().nullable(),
    taxAmount: z.number().nullable(),
    currency: z.string().length(3),
    category: z.string().nullable(),
    paymentMethod: z.string().nullable(),
    notes: z.string().nullable(),
    status: ReceiptStatusSchema,
    extractionStatus: ReceiptExtractionStatusSchema,
    extractedText: z.string().nullable(),
    extractedPayload: z.record(z.string(), z.unknown()),
    companyId: z.string().uuid().nullable(),
    projectId: z.string().uuid().nullable(),
    cashflowItemId: z.string().uuid().nullable(),
    uploadedBy: z.string().email(),
    reviewedBy: z.string().email().nullable(),
    reviewedAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const ReceiptListQuerySchema = z.object({
    status: ReceiptStatusSchema.optional(),
    extractionStatus: ReceiptExtractionStatusSchema.optional(),
    search: z.string().max(200).optional(),
    limit: z.coerce.number().int().min(1).max(100).default(50),
    offset: z.coerce.number().int().min(0).default(0),
});
export const ReceiptCreateSchema = z.object({
    filename: z.string().min(1).max(500),
    blobKey: z.string().min(1).max(1000),
    mimeType: z.string().max(100),
    sizeBytes: z.number().int().nonnegative(),
    supplierName: z.string().trim().max(240).optional(),
    receiptDate: z.string().date().optional(),
    totalAmount: z.number().nonnegative().optional(),
    taxAmount: z.number().nonnegative().optional(),
    currency: z.string().length(3).default("GBP"),
    category: z.string().trim().max(100).optional(),
    paymentMethod: z.string().trim().max(80).optional(),
    notes: z.string().trim().max(1000).optional(),
    companyId: z.string().uuid().nullable().optional(),
    projectId: z.string().uuid().nullable().optional(),
});
export const ReceiptUpdateSchema = ReceiptCreateSchema.pick({
    supplierName: true,
    receiptDate: true,
    totalAmount: true,
    taxAmount: true,
    currency: true,
    category: true,
    paymentMethod: true,
    notes: true,
    companyId: true,
    projectId: true,
}).partial();
export const ReceiptApproveSchema = z.object({
    supplierName: z.string().trim().min(1).max(240),
    receiptDate: z.string().date(),
    totalAmount: z.number().positive(),
    taxAmount: z.number().nonnegative().optional(),
    currency: z.string().length(3).default("GBP"),
    category: z.string().trim().max(100).optional(),
    paymentMethod: z.string().trim().max(80).optional(),
    notes: z.string().trim().max(1000).optional(),
});
export const ReceiptListResponseSchema = z.object({
    receipts: z.array(ReceiptSchema),
    total: z.number().int(),
});
export const ReceiptUploadTokenRequestSchema = z.object({
    filename: z.string().min(1).max(500),
    contentType: z.string().min(1).max(100),
});
export const ReceiptUploadTokenResponseSchema = z.object({
    uploadUrl: z.string().url(),
    blobKey: z.string().min(1),
    expiresAt: z.string().datetime(),
});
//# sourceMappingURL=receipts.js.map